<template>
  <UploadFichierState
    :idDemande="store.model!.id"
    :readonly
    :lov-nature-fichiers="lovNatureFichiers"
    :fichiers="model?.fichiers ?? []"
    :natures-fichiers-facultatifs="naturesFichiers.facultatifs"
    :natures-fichiers-obligatoires="naturesFichiers.obligatoires"
    :natures-fichiers-ajout-facultatifs="naturesFichiers.facultatifsDefaut"
    :nombre-fichiers-maximum="naturesFichiers.nombreFichiersMaximum"
    :nombre-fichiers-minimum="naturesFichiers.nombreFichiersMinimum"
    :fichier-add
    :fichier-remove
  >
    <DemandeTabsAF />
    <DemandeFooter
      v-if="!readonly || mustConfirm"
      :canPrintCerfa="false"
      :mustConfirm
      :canRefuse
      @save="actions.save"
      @transmit="actions.save(LevelRegleEnum.Transmettre)"
      @accept="actions.confirm(true)"
      @refuse="actions.confirm(false)"
    />
  </UploadFichierState>
</template>

<script setup lang="ts">
  import { computed, provide } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeAFStore } from './useDemandeAFStore'
  import DemandeTabsAF from './DemandeTabsAF.vue'
  import { LevelRegleEnum } from '@/features/domaine/types/opco'
  import { AF_INJECT, type DemandeAFActions } from './DemandeAF.type'
  import { useDemandeAFActions } from './useDemandeAFActions'
  import { DemandeFooter, UploadFichierState, useWatchModel } from '@/features/interface/demande/shared'
  import type { FichierDTO } from '@/features/api/extranet/dto/Demande/shared'
  import { SalarieActionKey, useSalarieActions, type SalarieAction } from './steps/salarie/useSalarieActions'
  import { ModuleActionKey, useModuleActions, type ModuleAction } from './steps/formation/useModuleActions'

  const store = useDemandeAFStore()
  const { meta, model, readonly, naturesFichiers, lov, mustConfirm, canRefuse } = storeToRefs(store)
  const actions = useDemandeAFActions()

  provide<SalarieAction>(SalarieActionKey, useSalarieActions())
  provide<ModuleAction>(ModuleActionKey, useModuleActions())
  provide<DemandeAFActions>(AF_INJECT, actions)

  const fichierAdd = store.setupCustomUpdater<FichierDTO>((patch, fichier) => {
    patch.fichiers!.push(fichier)
  })

  const lovNatureFichiers = computed(() => {
    if (model.value?.sousDispositif !== 'Fse') return lov.value.NatureFichier
    return lov.value.NatureFichier.map((item) => {
      if (item.code !== 'Programme') return item
      return {
        code: 'Programme',
        intitule: 'Programme (si séparé de projet de convention ou devis)',
      }
    })
  })

  const fichierRemove = store.setupCustomUpdater<FichierDTO>((patch, fichier) => {
    const index = patch.fichiers!.findIndex((item) => item.fichierUid === fichier.fichierUid)
    if (index > -1) {
      patch.fichiers!.splice(index, 1)
    }
  })

  useWatchModel(model, meta)
</script>
<style scoped lang="less">
  :deep(.fixed-footer__imprimer) {
    display: none;
  }
</style>
